import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "h4 mb-4 text-center" }, " Si vous avez terminé vos modifications, veuillez relivrer le questionnaire ", -1)
const _hoisted_3 = { class: "row no-gutters list-unstyled m-0" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Non, j'ai d'autres modifications")
const _hoisted_6 = { class: "col" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-truck-loading mr-1" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Relivrer le questionnaire ")


import ActionStatus from './ActionStatus.vue';
import { Alert } from '@/composables/alert';
import Button from "primevue/button";
import Dialog from 'primevue/dialog';
import { useDelivery } from '@/composables/delivery';

export type ActionProps = {
    campaignId: string;
};

interface Props extends ActionProps {
    visible: boolean;
    alert: Alert | null;
    campaignId: ActionProps['campaignId']; // obligé de re déclarer car "extends" ou "&" ne fonctionnent pas (limitation de version Vue)
}


export default /*#__PURE__*/_defineComponent({
  props: {
    visible: { type: Boolean },
    alert: null,
    campaignId: null
  },
  emits: ["update:visible"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'update:visible', v: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    visible: boolean;
    alert: Alert | null;
    campaignId: ActionProps['campaignId']; // obligé de re déclarer car "extends" ou "&" ne fonctionnent pas (limitation de version Vue)
}





function close() {
    emit('update:visible', false);
}

const { deliver } = useDelivery(props.campaignId);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: __props.visible,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (emit('update:visible', $event))),
    modal: "",
    "append-to": "self",
    style: { width: '30rem' },
    draggable: false,
    "close-on-escape": ""
  }, {
    footer: _withCtx(() => [
      (__props.alert && __props.alert.status === 'success')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_2,
            _createElementVNode("menu", _hoisted_3, [
              _createElementVNode("li", _hoisted_4, [
                _createVNode(_unref(Button), {
                  onClick: close,
                  class: "p-button-outlined"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_6, [
                _createVNode(_unref(Button), {
                  class: "mr-0",
                  onClick: _unref(deliver)
                }, {
                  default: _withCtx(() => [
                    _hoisted_7,
                    _hoisted_8
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ], 64))
        : (__props.alert)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [], 64))
          : _renderSlot(_ctx.$slots, "footer", { key: 2 })
    ]),
    default: _withCtx(() => [
      _createVNode(_Transition, null, {
        default: _withCtx(() => [
          (__props.alert)
            ? (_openBlock(), _createBlock(ActionStatus, {
                key: 0,
                alert: __props.alert
              }, null, 8, ["alert"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _renderSlot(_ctx.$slots, "default")
              ]))
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["visible"]))
}
}

})